import React from "react";
import { Tag, Brain, Mic } from "lucide-react";
import { PageHeader, Tabs, TabsList, TabsTrigger, TabsContent } from "../ui";
import CategoryManager from "./CategoryManager";
import "./AICategories.scss";

/**
 * AICategoriesHub — one place for an institute to manage the option lists that
 * power both AI student features:
 *   • Learn with AI          → tech stacks
 *   • Mock Interview with AI → Technology/Subject, Target Roles, Interview Types
 *
 * Institutes add their own entries and hide any built-in default they don't
 * want students to see. Reachable at /ai-categories with any AI feature.
 */
const AICategoriesHub = () => (
  <div className="ai-cats-hub">
    <PageHeader
      icon={Tag}
      title="AI Categories"
      description="Manage the options students see in Learn with AI and Mock Interview with AI. Add your own or hide the built-in ones."
    />

    <Tabs defaultValue="learn" className="ai-cats-hub-tabs">
      <TabsList>
        <TabsTrigger value="learn"><Brain size={14} /> <span>Learn with AI</span></TabsTrigger>
        <TabsTrigger value="mock"><Mic size={14} /> <span>Mock Interview</span></TabsTrigger>
      </TabsList>

      <TabsContent value="learn">
        <CategoryManager
          type="learn_tech"
          title="Tech Stacks"
          description="Topics students can practice in Learn with AI. Question counts reflect your AI Question Bank."
          addPlaceholder="e.g. GraphQL, Rust, System Design"
          showCounts
        />
      </TabsContent>

      <TabsContent value="mock">
        <div className="ai-cats-hub-stack">
          <CategoryManager
            type="mock_tech"
            title="Technology / Subject"
            description="Subjects a student can pick when starting a mock interview."
            addPlaceholder="e.g. Rust, Salesforce, Data Engineering"
          />
          <CategoryManager
            type="mock_role"
            title="Target Roles"
            description="Roles a student can interview for."
            addPlaceholder="e.g. Site Reliability Engineer, BI Analyst"
          />
          <CategoryManager
            type="mock_type"
            title="Interview Types"
            description="Kinds of interview a student can choose (e.g. Technical, HR)."
            addPlaceholder="e.g. Managerial, Case Study"
          />
        </div>
      </TabsContent>
    </Tabs>
  </div>
);

export default AICategoriesHub;
